<template>
    <div>
        <main>
            <CxServices />
        </main>
    </div>
</template>

<script>
import CxServices from '@/components/CxServices.vue'

export default {
    components: {
        CxServices
    }}
</script>